export default "__VITE_ASSET__BjMzHhfA__"